// src/directives/animate.js
import 'animate.css/animate.min.css';

export const vAnimate = {
    mounted(el, binding) {
        // 设置初始状态
        el.style.opacity = '0';

        // 获取动画类型，默认为fadeInUp
        const animation = binding.value || 'fadeInUp';

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 添加动画类
                    el.classList.add('animate__animated', `animate__${animation}`);
                    el.style.opacity = '1';

                    // 动画结束后停止观察
                    observer.unobserve(el);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        });

        observer.observe(el);
    }
};